
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class AttendanceDetailsDialog extends Serenity.EntityDialog<AttendanceDetailsRow, any> {
        protected getFormKey() { return AttendanceDetailsForm.formKey; }
        protected getIdProperty() { return AttendanceDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return AttendanceDetailsRow.localTextPrefix; }
        protected getService() { return AttendanceDetailsService.baseUrl; }
        protected getDeletePermission() { return AttendanceDetailsRow.deletePermission; }
        protected getInsertPermission() { return AttendanceDetailsRow.insertPermission; }
        protected getUpdatePermission() { return AttendanceDetailsRow.updatePermission; }

        protected form = new AttendanceDetailsForm(this.idPrefix);

    }
}